import TnC from '@/components/(Company)/TnC';

export default function TermsPage() {
  return (
    <div className="">
      <TnC />
    </div>
  );
} 